import React from "react";
import html2canvas from "html2canvas";
import "./MultiSOAPrint.css";

// Component to render multiple SOAs on one page, 4 per letter-size page (2 columns x 2 rows)
export default function MultiSOAPrint({ selectedStudents, generateSOA }) {
  return (
    <div className="multi-soa-print-container">
      {selectedStudents.map((student, index) => (
        <div key={student.id} className="soa-card">
          {generateSOA(student)}
        </div>
      ))}
    </div>
  );
}